import { call, put, select, takeLatest } from 'redux-saga/effects';
import { PICK_STEP, SUBMIT_PICKS } from './constants';
import { endPicks, submitPicks } from './actions';
import { selectPicksMade, selectPicksSource, selectPicksSteps } from './selectors';
import { picksRequest } from './steps';
import gameTurnService from '../services/gameTurn';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { closeContextMenu } from '../ActiveGame/actions';
import { selectActiveGame, selectActivePokemon, selectBench, selectOpponentBenchSeen } from '../ActiveGame/selectors';
import { selectCurrentUser } from '../Login/selectors';
import { waitForUndo } from '../Undo/waitForUndo';
import { undoDone } from '../Undo/actions';
import { swapWords } from '../Undo/swapWords';
import { TRAINER } from './constants';
import { trainerWaits } from '../Undo/undoableMoves';

// The last step's pick plays the Trainer or uses the Power.
function* pickStepTask() {
  const picks = yield select(selectPicksMade);

  if (picks.size === (yield select(selectPicksSteps)).size) {
    yield put(submitPicks(yield select(selectPicksSource), picks));
  }
}

// The flow ends even when the server refuses, so the board never stays stuck waiting for a choice.
function* submitPicksTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');
  const source = action.payload.get('source');
  const picks = picksRequest(action.payload.get('picks'));

  try {
    // Some Trainers wait with an Undo first (Undo/undoableMoves).
    const undoTitle = source.get('kind') === TRAINER ? trainerWaits(source.get('name')) : null;
    if (undoTitle) {
      const userId = (yield select(selectCurrentUser)).get('id');
      const active = yield select(selectActivePokemon, { userId });
      const bench = yield select(selectBench, { userId });
      const benchPosition = action.payload.getIn(['picks', 0, 'at']);
      if (yield call(waitForUndo, undoTitle, swapWords(active, bench, benchPosition), { swap: { userId, benchPosition } })) {
        yield put(closeContextMenu());
        return;
      }
    }
    const benchSeen = yield select(selectOpponentBenchSeen);
    const game = source.get('kind') === 'power'
      ? yield call(gameTurnService.power, gameId, source.get('at'), source.get('moveId'), picks, benchSeen)
      : yield call(gameTurnService.trainer, gameId, source.get('handPosition'), picks, benchSeen);
    yield call(handleUpdateGame, game);
    yield put(closeContextMenu());
  } finally {
    yield put(undoDone());
    yield put(endPicks());
  }
}

function* pickStepWatcher() {
  yield takeLatest(PICK_STEP, pickStepTask);
}

function* submitPicksWatcher() {
  yield takeLatest(SUBMIT_PICKS, submitPicksTask);
}

export default [
  pickStepWatcher,
  submitPicksWatcher,
];
